import React from 'react';
import { Div, Divider, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { SearchSectionProps } from './search-section.props';
import { HomeActions } from '@store/home-screen/home-action';
import { useDispatch } from 'react-redux';
import { parsePrice } from '@utils/helpers/parse-price';
import Link from 'next/link';

const SearchSection = ({ data, loading, type, lastSection = false, hasPrice = false, title } : SearchSectionProps) => {
  const dispatch = useDispatch();
  const handleRedirect = ({ slug } : {slug: string}) => {
    dispatch(HomeActions.setSearchResults({
      users: [],
      products: [],
      posts: [],
      is_empty: true,
    }));
    dispatch(HomeActions.setSearchValue({ value: '' }));
  };

  if (data && data.length && !loading) {
    return (
      <Div className={'flex-col w-full gap-2'}>
        <Text type={'bold'} align={'right'}>{title}</Text>
        {data.map((item: {title: string, slug: string, image?: string, price?: number}, index: number) => (
          <Link passHref={true} href={`/${type}/${item.slug}`} onClick={() => handleRedirect({ slug: item.slug })} key={`result_${index}`} className={'flex flex-row w-full hover:text-white gap-2 items-center cursor-pointer hover:bg-primary rounded px-0.5'}>
            {item.image ? (
              <span className={'min-w-6 w-6 h-6 relative object-cover'}>
                <Image src={item.image} fill={true} alt={`تصویر ${item.title}`} />
              </span>
            ) : null}
            <Text className={'text-ellipsis w-full whitespace-nowrap overflow-hidden'} align={'right'} color={'inherit'} typography={'sm'}>
              {item.title}
            </Text>
            {hasPrice ? (
              <Text color={'inherit'} className={'whitespace-nowrap'} typography={'sm'}>{item.price ? `${parsePrice(item.price)} تومان` : 'ناموجود'}</Text>
            ) : null}
          </Link>
        ))}
        {lastSection ? null : ( <Divider /> )}
      </Div>
    );
  }

  return null;
};

export default SearchSection;
